<template>
  <div class="mt-4">
    <p>
      <span class="font-weight-bold black--text">Step {{ step.number }}:</span> {{ step.step }}
      <template v-if="step.description">
        <br />
        <template v-if="step.description">
          <div class="text-subtitle-1" v-if="step.htmlDescription" v-html="step.description"></div>
          <span class="text-subtitle-1" v-else>{{ step.description }}</span>
        </template>
      </template>
    </p>
    <div class="ml-8">
      <v-img
        v-if="step.img"
        contain
        max-width="1000"
        :src="step.img"
        :alt="`step_${step.number}`"></v-img>
      <!-- @slot Step Item default slot -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      required: true
    }
  }
};
</script>
